export function formatPhoneNumber(phoneNumber: string, countryCode: string): string {
    if (countryCode === "1" && phoneNumber.length === 10) {
        // US/Canada
        return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
    }
    return `+${countryCode} ${phoneNumber}`;
}
